module.exports = __webpack_public_path__ + "img/nol-back.a1b4b08f.png";